"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.StyledEmpty = exports.StyledButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _utils = require("../lib/utils");

var _templateObject, _templateObject2, _templateObject3;

var StyledEmpty = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  padding: 20px 0px;\n  min-width: 200px;\n  justify-content: center;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), _styledSystem.space, _styledSystem.width, _styledSystem.height, _styledSystem.color);

exports.StyledEmpty = StyledEmpty;

var StyledText = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  padding-top: 14px;\n"])), (0, _utils.getTypography)('bodyLight'));

exports.StyledText = StyledText;

var StyledButton = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: 18px;\n"])));

exports.StyledButton = StyledButton;